<template>
    <div class="PvEnvironmental">
        <Title firstName="经济效益" lastName="ECONOMIC BENEFIT" />
        <div class="content">
            <div class="economic" >
                <div class="eleft">
                    <div class="econ">
                        <div class="eimg">
                            <img src="../../../assets/img/economic2.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="eright">
                    <p>累计节约成本</p>
                    <p>{{(88.94 * 70).toFixed(2)}}<span> ￥</span></p>
                    <p>本日节约：<span>88.94<i> ￥</i></span></p> 
                    <p>本月节约：<span>{{(88.94 * new Date().getDate()).toFixed(2)}}<i> ￥</i></span></p> 
                    <p>本年节约：<span>{{(88.94 * 47).toFixed(2)}}<i> ￥</i></span></p> 
                </div>
            </div>
            
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title')
export default {
    data(){
        return {
        }
    },
    watch: {
    },
    components:{
        Title
    },
    
    mounted(){
    },
    methods:{
    }
}
</script>

<style lang="less" scoped>
    .PvEnvironmental{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 68.1vh;
        right: 1vw;

        .content{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);


            .economic{
                height: 24vh;
                overflow: hidden;
                .eleft{
                    float: left;
                    width: 7.8vw;
                    height: 100%;
                    position: relative;
                    .econ{
                        width: 6vw;
                        height: 17vh;
                        padding: 4rem;
                        border: 1px solid #0D94FF;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                        .eimg{
                            width: 100%;
                            height: 100%;
                            background-color: rgba(13,148,255, 0.3);
                            img{
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%,-50%);
                            }
                        }
                    }
                }
                .eright{
                    float: left;
                    width: 12vw;
                    height: 100%;
                    position: relative;
                    padding-left: 1vw;
                    padding-top: 5vh;
                    p:nth-child(1){
                        color: rgba(230,243,253, 0.7);
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;   
                    }
                    p:nth-child(2){
                        padding-top: 0.5vh;
                        padding-bottom:2vh ;
                        color: #FFCD8B;
                        font-size: 30rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;   
                        span{
                            font-size: 18rem;
                        }
                    }
                    p:nth-child(3),p:nth-child(4),p:nth-child(5){
                        padding-bottom: 0.7vh;
                        color: rgba(230,243,253, 0.7);
                        font-size: 14rem;
                        font-family: SourceHanSansCN-Regular;
                        font-weight: 400;   
                        span{
                            font-size: 20rem;
                            color: #00DEFF;
                            font-family: zcoolqingkehuangyouti;
                            i{
                                font-style: normal;
                                font-family: SourceHanSansCN-Regular;
                                font-size: 14rem;
                            }
                        }
                    }
                }
                .eright::before{
                    content: '';
                    width: 100%;
                    height: 1rem;
                    background-color: rgba(255, 255, 255, 0.3);
                    position: absolute;
                    left: 0;
                    top: 11.5vh;
                }
                .eright::after{
                    content: '';
                    width: 1rem;
                    height: 1rem;
                    border: 1rem solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.3);
                    position: absolute;
                    left: -1rem;
                    top:calc(11.5vh - 2rem) ;
                }
            }
            
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>